module.exports = __webpack_public_path__ + "img/fire.5c5db4f6.svg";